import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true,
})
export class FooterComponent {
  public year: number;
  constructor() {
    let date: Date = new Date();
    this.year = date.getFullYear();
  }
}
